<ngx-loading-bar></ngx-loading-bar>
<mat-sidenav-container class="app" [ngClass]="{
  'mode-boxed': options.boxed,
  'mode-docked': options.docked,
  'theme-winter': options.theme === 'winter',
  'theme-spring': options.theme === 'spring',
  'theme-autumn': options.theme === 'autumn',
  'theme-summer': options.theme === 'summer',
  'theme-eclipse': options.theme === 'eclipse',
  'mobile-view': isOver(),
  'no-footer': routeOptions()?.removeFooter}">
  <mat-sidenav class="sidebar-panel" #sidemenu id="admin-layout-sidebar-panel"
               [mode]="isOver() ? 'over' : 'side'"
               [opened]="sidenavOpened()"
               (openedChange)="sidenavOpened.set($event)"
               [fixedInViewport]="true"
               [fixedTopGap]="0"
               [fixedBottomGap]="0"
               [disableClose]="false"
               [autoFocus]="true"
               tabindex="0">
    <app-sidebar (messageEvent)="receiveMessage($event)" (toggleFullscreen)="toggleFullscreen()" (menuClick)="onMenuClick()" class="bg-cover"></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header (toggleSidenav)="toggleSidenav()" [heading]="routeOptions().heading"></app-header>

    <div class="main-content">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
